import { render, staticRenderFns } from "./DatabaseBackupList.vue?vue&type=template&id=0ac05761&"
import script from "./DatabaseBackupList.vue?vue&type=script&lang=ts&"
export * from "./DatabaseBackupList.vue?vue&type=script&lang=ts&"
import style0 from "./DatabaseBackupList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSimpleTable,VTooltip})
